import { TS_Donation }          from '../TravelSeller/Models/TS_Donation';
import { BookingItemInterface } from './BookingItemInterface';

export class Donation extends TS_Donation implements BookingItemInterface {

}